/**
 * Trailing-edge debounce: run `fn` once, `wait` ms after its last call.
 *
 * Timing comes from setTimeout alone, with no clock reads. `Date.now()` in this
 * app is the server clock (see serverClock.js) and the server clock can be
 * frozen, so an elapsed-time comparison against it stays at zero and a wait
 * measured that way never completes. Anything that measures a duration needs
 * either this helper or `localNow()`.
 */
export default function debounce(fn, wait) {
    let timer = null;

    const debounced = (...args) => {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
            timer = null;
            fn(...args);
        }, wait);
    };

    /** Drop a pending call. */
    debounced.cancel = () => {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    };

    return debounced;
}
